import isEmpty from 'lodash/isEmpty';
var empty = function empty(data) {
  return isEmpty(data);
};
export default empty;